import React from 'react';
import { FlameIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { PriceBlock } from '../PriceBlock';
import { OFFER_SECTION_ID } from '../../data/salesContent';
export function OfferSection() {
  return <section id={OFFER_SECTION_ID} className="scroll-mt-4 bg-zinc-900 px-5 py-20 md:py-28" aria-labelledby="offer-title" data-id="element-147" data-mp="fgl7yiatxfbn">
      <div className="mx-auto max-w-3xl overflow-hidden rounded-2xl border-2 border-amber-400 bg-zinc-950" data-id="element-148" data-mp="akw78bn2psdr">
        <div className="border-b border-zinc-800 bg-zinc-900/60 px-6 py-10 text-center md:px-12" data-id="element-149" data-mp="6j17hbksjn23">
          <FlameIcon className="mx-auto h-8 w-8 text-amber-400" aria-hidden="true" data-id="element-150" data-mp="1on70ur9upqk" />
          <h2 id="offer-title" className="font-display mt-4 text-4xl font-extrabold uppercase leading-[1.05] text-zinc-50 md:text-5xl" data-id="element-151" data-mp="3sx2fhite37mx">
            Todo un sistema de formación, <span className="text-amber-400" data-id="element-152" data-mp="3ixjz1ccou3zm">en un solo pack.</span>
          </h2>
          <p className="font-display mt-4 text-xl font-bold uppercase tracking-widest text-zinc-400 md:text-2xl" data-id="element-153" data-mp="3ewhzeueuzpx4">6 volúmenes + 5 bonos</p>
        </div>
        <div className="px-6 py-10 text-center md:px-12" data-id="element-154" data-mp="1apxmupxry9hi">
          <PriceBlock lead="Hoy por" data-id="element-155" data-mp="1fjsfwjz9s0t9" />
          <div className="mt-8" data-id="element-156" data-mp="1fktrqqo40rc1">
            <CtaButton data-id="element-157" data-mp="10u4ezjv03462">Quiero acceder al Mega Pack</CtaButton>
          </div>
        </div>
      </div>
    </section>;
}